<template>
  <div class="checkout d-flex align-items-stretch">
    <div class="payment">
      <div class="mb-1 ml-4 logo">
        <img
          v-if="theme.brandLogo"
          :src="theme.brandLogo"
          alt=""
          class="img-fluid"
        >
        <!-- <p class=" d-none d-sm-block"><a href="">&lt; Back to previous step</a></p> -->
      </div>

      <section class="mt-4 d-block d-sm-none">
        <div class="summary-content-mobile">
          <shopping-cart
            :total="total"
            :currency-code="currencyCode"
            :products="products"
            @onCurrencyChange="onCurrencyChange"
          />
        </div>
      </section>

      <form
        ref="form"
        @submit.prevent.stop="startOrderSubmission"
      >
        <section class="mb-1">
          <header class="my-1 ml-4">
            Contact Information
          </header>
          <mdc-grid-container>
            <mdc-grid>
              <mdc-grid-cell :cols="12">
                <mdc-text-field
                  v-model="contact.email"
                  type="email"
                  label="Email"
                  required
                  @change="updateCartField('contact.email', $event)"
                />
              </mdc-grid-cell>
            </mdc-grid>
          </mdc-grid-container>
        </section>

        <section class="mb-1">
          <header class="my-1 ml-4">
            Payment Method
          </header>
          <credit-card-form v-model="creditCard" />
        </section>

        <section v-if="settings.billingAddress">
          <header class="my-1 ml-4">
            Billing Address
          </header>
          <address-form
            v-model="billingAddress"
            :google-maps-api-key="googleMapsApiKey"
            :disabled-fields="disabledBillingFields"
          />
        </section>

        <section>
          <mdc-grid-container>
            <mdc-grid>
              <mdc-grid-cell :cols="12">
                <mdc-button raised>
                  PAY NOW
                </mdc-button>
                <div class="mobile-footer d-block d-sm-none ">
                  <!-- <p class="text-center mt-3"><a href="">&lt; Back to previous step</a></p> -->
                  <div class="copyright mt-4 row d-flex text-center justify-content-around">
                    <div class="col-sm">
                      <a href="#">Refund policy</a>
                    </div>
                    <div class="col-sm">
                      <a href="#">Privacy policy</a>
                    </div>
                    <div class="col-sm">
                      <a href="#">Terms of service</a>
                    </div>
                  </div>
                </div>
              </mdc-grid-cell>
            </mdc-grid>
          </mdc-grid-container>
        </section>
      </form>
    </div>

    <div class="summary">
      <div class="summary-content d-none d-sm-block">
        <shopping-cart
          :total="total"
          :currency-code="currencyCode"
          :products="products"
          @onCurrencyChange="onCurrencyChange"
        />
        <coupon v-if="settings.promoCode" />
        <div
          v-if="false"
          class="copyright mt-2 row d-flex justify-content-around"
        >
          <div class="col">
            <a href="#">Refund policy</a>
          </div>
          <div class="col">
            <a href="#">Privacy policy</a>
          </div>
          <div class="col">
            <a href="#">Terms of service</a>
          </div>
        </div>
      </div>
    </div>

    <sweet-modal
      ref="errorDialog"
      icon="error"
      overlay-theme="dark"
      modal-theme="light"
      blocking
      hide-close-button
    >
      <h4
        class="text-danger"
        v-text="errorText"
      />
      <!-- <mdc-button @click="$refs.errorDialog.close()" slot="button" :full-width="false">Close</mdc-button> -->
      <button
        slot="button"
        class="btn btn-outline btn-outline-danger"
        @click="$refs.errorDialog.close()"
      >
        Close
      </button>
    </sweet-modal>

    <sweet-modal
      ref="successDialog"
      icon="success"
      overlay-theme="dark"
      modal-theme="light"
      blocking
      hide-close-button
    >
      <h4 class="text-success">
        Thank you for your purchase!
      </h4>
      <p v-if="settings.successAction">
        You'll be redirected shortly
      </p>
      <p v-else>
        You may now close this page.
      </p>
    </sweet-modal>

    <sweet-modal
      ref="processingDialog"
      overlay-theme="dark"
      modal-theme="light"
      blocking
      hide-close-button
    >
      <h4 class="text-center text-success">
        <font-awesome-icon
          icon="circle-notch"
          size="lg"
          spin
        />
      </h4>
      <h4>Hang tight we're processing your order, this might take a moment.</h4>
    </sweet-modal>
  </div>
</template>

<script>
import * as _ from 'lodash'
import { mapState, mapActions } from 'vuex'
import { creditCard } from '../../../storybook/components/checkout/CreditCard'
import { address } from '../../../storybook/components/checkout/Address'

export default {
  name: 'Checkout',
  components: {},
  data () {
    return {
      errorText: '',
      disabledBillingFields: ['firstName', 'lastName', 'company', 'phone'],
      creditCard: creditCard(),
      billingAddress: address()
    }
  },
  computed: {
    contact () {
      return _.get(this.cart, 'contact', {})
    },
    ...mapState('config', {
      googleMapsApiKey: 'googleApiKey'
    }),
    ...mapState('shoppingCart', {
      cart: 'cart',
      products: 'products',
      processing: 'processing',
      total: 'total',
      currencyCode: 'currencyCode'
    }),
    ...mapState('site', {
      site: 'site',
      theme: state => _.get(state, 'site.config.theme', {}),
      settings: state => _.get(state, 'site.config.checkout', {})
    })
  },
  watch: {
    processing (processing) {
      this.$refs.form.disabled = processing
      const method = processing ? 'open' : 'close'
      this.$refs.processingDialog[method]()
    }
  },
  methods: {
    ...mapActions('shoppingCart', {
      updateDetails: 'updateDetails',
      getCreditCardID: 'getCreditCardID',
      submitOrder: 'submitOrder',
      recalculateTotal: 'recalculateTotal',
      onCurrencyChange: 'updateCurrency'
    }),
    async updateCartField (field, value) {
      return this.updateDetails({
        [field]: value
      })
    },

    async startOrderSubmission () {
      if (!this.$refs.form.reportValidity()) {
        return
      }

      try {
        const [firstName, lastName] = this.creditCard.name.split(' ')
        await this.updateDetails({
          'contact.firstName': firstName,
          'contact.lastName': lastName
        })
        const response = await this.submitOrder({
          creditCard: this.creditCard,
          billingAddress: this.settings.billingAddress && this.billingAddress
        })
        const { data } = response
        if (data.success === false) {
          const err = new Error('Failed to order submission')
          err.response = response
          throw err
        }
        this.$refs.successDialog.open()

        if (this.settings.successAction) {
          setTimeout(() => {
            let url = ''

            switch (this.settings.successAction) {
              case 'page':
                const page = _.find(this.site.pages, p => p.id === this.settings.successPage)
                url = page.path
                break
              case 'link':
                url = this.settings.successURL
                break
            }

            if (url) window.location.href = url
          }, 3500)
        }
      } catch (err) {
        console.debug('failed to process order', err)
        const { response = {} } = err
        const { data = {} } = response
        const { errors = [] } = data

        if (errors.length) {
          this.errorText = _.get(errors, '[0].message', 'Something went wrong. Please try again.')
          this.$refs.errorDialog.open()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .checkout {
    padding: 0 5%;
    width: 90%;
    max-width: 80em;
    display: block;
    margin: 0 auto;
    height: 100vh;
    overflow: visible;
    section {
      header {
        font-weight: 300;
        font-family: Roboto;
        font-size: 1.5rem;
      }
    }
    a {
      color: #4f566b;
    }
  }

  .checkout:before, .checkout:after {
      content: "";
      display: table;
    }
  .checkout:after {
    clear: both;
  }
  .payment,.summary {
    padding-top: 4em;
  }

  .payment {
    width: 52%;
    padding: 02% 6% 6% 0;
    float: left;
  }
  .summary {
    position: relative;
    &:after {
      content: "";
      display: block;
      width: 48vw;
      position: absolute;
      top: 0;
      left: 0%;
      bottom: 0;
      background: #f7fafc;
      border-left: 1px solid #e8e8e8;
      z-index: -1;
    }
  }

  .summary-content {
    margin-top: 10em;
  }
  .copyright {
    font-size: .8rem;
  }

  .checkout-coupon-code {
    border-top: solid 1px #e3e8ee;
    border-bottom: solid 1px #e3e8ee;
  }

  @media (min-width: 1000px) {
    .summary {
      width: 38%;
      padding-left: 4%;
      background-position: left top;
      float: right;
      &:after {
        // left: 0;
        // background-position: left top;
      }
    }
  }

  @media (max-width: 749px) {
    .checkout {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      max-width: 100%;
    }

    .payment {
      width: 100%
    }

    .summary {
      padding-top: .2em;
      width: 100%;
      &:after {
        display: none;
      }

    }
  }
</style>
